<template>
  <BlankLayout v-if="useBlank" />
  <MainLayout v-else />
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from './stores/auth';
import MainLayout from './layouts/MainLayout.vue';
import BlankLayout from './layouts/BlankLayout.vue';

const route = useRoute();
const auth = useAuthStore();
const useBlank = computed(() => route.meta && route.meta.layout === 'blank');

onMounted(() => {
  auth.checkSession().catch(() => {});
});
</script>
